module.exports = __webpack_public_path__ + "static/media/fx-sign.6dc4d20a.png";